module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "dedicationText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("To Nate V. N."), _c('br'), _vm._v("\nThank you for never getting tired of my endless quest"), _c('br'), _vm._v("\nfor “just the right word” and for keeping your"), _c('br'), _vm._v("\nsnickering to a minimum when I sing in the shower."), _c('br'), _vm._v("\nNate, you make my heart smile.")])])])]), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "dedicationText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("T. A. I.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f8d38df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416538318_ded.vue
// module id = 66
// module chunks = 0